import { Component, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';
import { HttpBasicService } from 'src/app/service/http-basic.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NumberKeypadComponent } from 'src/app/partsCommon/number-keypad/number-keypad.component';
import { ItemRec } from 'src/app/common/item-rec';
import { Subscription, Observable } from 'rxjs';
import { ReqItemSearch } from 'src/app/request/req-item-search';
import { RspItemSearch } from 'src/app/response/rsp-item-search';
import { RspOrderEdit, RspOrderEditDto } from 'src/app/response/rsp-order-edit';
import { RspStockEdit, RspStockEditDto } from 'src/app/response/rsp-stock-edit';
import { ReqParamItemEdit } from 'src/app/request/req-param-item-edit';
import { RspParamItemEdit } from 'src/app/response/rsp-param-item-edit';
import { ReqOrderStopItemEdit } from 'src/app/request/req-order-stop-item-edit';
import { RspOrderStopItemEdit, OrderStopItemResultDto } from 'src/app/response/rsp-order-stop-item-edit';
import { ItemSummaryComponent } from 'src/app/partsCommon/item-summary/item-summary.component';
import { BarcodeDialogComponent } from 'src/app/dialog/barcode-dialog/barcode-dialog.component';

@Component({
  selector: 'app-scan-item-edit',
  templateUrl: './scan-item-edit.component.html',
  styleUrls: ['./scan-item-edit.component.css']
})
export class ScanItemEditComponent implements OnInit, OnDestroy {

  public storeForm: FormControl;

  public formGroup: FormGroup;
  public orderForm: FormControl;
  public stockForm: FormControl;
  public minZaiForm: FormControl;
  public maxZaiForm: FormControl;
  public minStockDaysForm: FormControl;
  public maxStockDaysForm: FormControl;
  public orderStopForm: FormControl;
  public inputItemCdForm: FormControl = new FormControl("");

  public itemRec: ItemRec;
  public orderStopList: {value: number, name: string, canOrder: boolean, changeable:boolean}[] = [];
  public orderStopInitial: string = "";
  public orderErrorMessage: string;
  public orderStopErrorMessage: string;
  public isOrderEditable: boolean = false;
  public isStockEditable: boolean = false;
  public isParamEditable: boolean = false;
  public isOrderStopEditable: boolean = false;

  private isReadonly: boolean = false;
  private keypadTargetId: string;
  private nextJanCode: string = "";
  private fullScreenWithError: boolean = true;    // Recal full screen at ths first query
  private subscriptionStore: Subscription;
  private subscriptionConfirm: Subscription;
  private subscriptionQuery: Subscription;

  @ViewChild(NumberKeypadComponent, {static: true}) numberKeypadComponent: NumberKeypadComponent;

  constructor(
    public commonService: CommonService,
    public httpBasic: HttpBasicService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    // this.commonService.pageTitle = "スキャン";
    this.commonService.pageTitle = this.commonService.pageMenuName;
    this.isReadonly = this.commonService.checkPrivilege("scanitem");

    this.isOrderEditable = !this.commonService.checkPrivilegeNoRedirect("order"); 
    this.isStockEditable = !this.commonService.checkPrivilegeNoRedirect("stock");
    this.isParamEditable = !this.commonService.checkPrivilegeNoRedirect("itemparam");
    this.isOrderStopEditable = !this.commonService.checkPrivilegeNoRedirect("autotrgt");

    this.storeForm = new FormControl(this.commonService.loginUser.storeCd);
    this.subscriptionStore = this.storeForm.valueChanges.subscribe(
      (store) => {this.storeChanged(store);}
    );

    this.formGroup = this.fb.group(
      {
        orderForm: [""],
        stockForm: [""],
        orderStopForm: [""],
        paramForm: this.fb.group({
            minZaiForm : [
              "",
              (fc:FormControl) => {
                return this.paramRangeValidator(
                  fc,
                  this.commonService.config.paramItemMinZaiRange.min,
                  this.commonService.config.paramItemMinZaiRange.max,
                  "最低陳列");
              }
            ],
            maxZaiForm : [
              "",
              (fc:FormControl) => {
                return this.paramRangeValidator(
                  fc,
                  this.commonService.config.paramItemMaxZaiRange.min,
                  this.commonService.config.paramItemMaxZaiRange.max,
                  "最大陳列");
              }
            ],
            minStockDaysForm : [
              "",
              (fc:FormControl) => {
                return this.paramRangeValidator(
                  fc,
                  this.commonService.config.paramItemMinStockDaysRange.min,
                  this.commonService.config.paramItemMinStockDaysRange.max,
                  "最低在庫日数");
              }
            ],
            maxStockDaysForm : [
              "",
              (fc:FormControl) => {
                return this.paramRangeValidator(
                  fc,
                  this.commonService.config.paramItemMaxStockDaysRange.min,
                  this.commonService.config.paramItemMaxStockDaysRange.max,
                  "最大在庫日数");
              }
            ]
          }
        )
      },
      {
        validators: (fg:FormGroup) => {return this.groupValidator(fg, this.itemRec)}
      }
    );

    this.orderForm = this.formGroup.get("orderForm") as FormControl;
    this.stockForm = this.formGroup.get("stockForm") as FormControl;
    this.orderStopForm = this.formGroup.get("orderStopForm") as FormControl;
    this.minZaiForm = this.formGroup.get("paramForm").get("minZaiForm") as FormControl;
    this.maxZaiForm = this.formGroup.get("paramForm").get("maxZaiForm") as FormControl;
    this.minStockDaysForm = this.formGroup.get("paramForm").get("minStockDaysForm") as FormControl;
    this.maxStockDaysForm = this.formGroup.get("paramForm").get("maxStockDaysForm") as FormControl;
    this.formGroup.disable();

    // this.orderStopList = this.commonService.getOrderStopSelectList();

    if (this.commonService.config.isHSD || this.commonService.config.scanFullScreen) {
      document.getElementById("inner-container").style.transform = "scale(1.0)";
      document.documentElement.requestFullscreen();
      let delay = 1000;
      if (this.commonService.config.delayAfterFullScreen) delay = this.commonService.config.delayAfterFullScreen;
      setTimeout(() => {this.scaleContainer();}, delay);
    }
  }

  scaleScreen() {
    /*
    document.getElementById("inner-container").style.transform = "scale(1.0)";
    document.documentElement.requestFullscreen();
    */
    let delay = 1000;
    if (this.commonService.config.delayAfterFullScreen) delay = this.commonService.config.delayAfterFullScreen;
    setTimeout(() => {this.scaleContainer();}, delay);
  }

  getCurrentScale(elem: Element) {
    let prop: string = window.getComputedStyle(elem).getPropertyValue('transform');
    if (prop && prop.startsWith("matrix")) {
      return parseFloat(prop.split(",")[3]);
    } else {
      return 1.0;
    }
  }

  scaleContainer() {
    let id = "inner-container";
    let containerElement = document.getElementById(id);
    let containerRect = containerElement.getBoundingClientRect();
    let areaHeight = window.innerHeight - containerRect.top - 37;
    let areaWidth  = window.innerWidth - 5;
    let scaleH = areaHeight / containerRect.height;
    let keypadRect = document.getElementById("keypad-container").getBoundingClientRect();
    let scaleW = areaWidth / keypadRect.right;
    // let scale = Math.min(scaleH, scaleW);
    let cscale = this.getCurrentScale(containerElement);
    let scale = Math.min(scaleH, scaleW) * cscale;
    
    document.getElementById(id).style.transformOrigin = "top left";
    document.getElementById(id).style.transform = "scale(" + scale + "," + scale + ")";
  }

  ngOnDestroy() {
    if (this.subscriptionStore) {
      this.subscriptionStore.unsubscribe();
    }
    if (this.subscriptionConfirm) {
      this.subscriptionConfirm.unsubscribe();
    }
    if (this.subscriptionQuery) {
      this.subscriptionQuery.unsubscribe();
    }
    if (this.commonService.config.isHSD || this.commonService.config.scanFullScreen) {
      document.getElementById("inner-container").style.transformOrigin = "top left";
      document.getElementById("inner-container").style.transform = "scale(1.0)";
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    }
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    event.preventDefault();

    if (event.key == "Enter" && this.nextJanCode != "") {
      let deactivate = this.canDeactivate();
      if (deactivate == true) {
        this.queryItem();
        return;
      }
      this.subscriptionConfirm = (deactivate as Observable<boolean>).subscribe(
        response => {
          if (response == true) {
            this.queryItem();
          } else {
            this.subscriptionConfirm.unsubscribe();
            this.subscriptionConfirm = undefined;
          }
        }
      );
      return;
    }

    if (isNaN(parseInt(event.key))) {
      this.nextJanCode = "";
    } else {
      this.nextJanCode += event.key;
    }

    /* DEBUG
    if (event.key == "a") this.nextJanCode = "4902522650045";
    if (event.key == "b") this.nextJanCode = "4968250280121";
    */
  }

  storeChanged(storeCd: string) {
    let deactivate = this.canDeactivate();
    if (deactivate == true) {
      this.clearItem();
      return;
    }
    this.subscriptionConfirm = (deactivate as Observable<boolean>).subscribe(
      response => {
        if (response == true) {
          this.clearItem();
        } else {
          this.subscriptionConfirm.unsubscribe();
          this.subscriptionConfirm = undefined;
        }
      }
    );
  }

  clearItem() {
    this.itemRec = undefined;
    this.orderStopInitial = "";
    this.formGroup.reset();
    this.keypadTargetId = undefined;
    this.numberKeypadComponent.inputField = undefined;
    this.orderErrorMessage = undefined;
    this.orderStopErrorMessage = undefined;
  
    this.orderStopForm.disable();

    /*
    this.orderForm.setValue("");
    this.stockForm.setValue("");
    this.minZaiForm.setValue("");
    this.maxZaiForm.setValue("");
    this.minStockDaysForm.setValue("");
    this.maxStockDaysForm.setValue("");
    this.orderStopForm.setValue("");
    this.formGroup.markAsPristine();
    */
  }

  use10KeyPad() {
    return this.commonService.config.use10KeyPad;
  }

  is10KeyPadTarget(id: string) {
    // if (!this.use10KeyPad()) return false;
    if (id === this.keypadTargetId) return true;
    return false;
  }

  set10KeyPadTarget(id: string, form: FormControl) {
    let ignore = false;
    if (!this.itemRec && id != "inputItemCd") ignore = true;
    if (id == "orderNum" && !this.commonService.getOrderStopFlagCanOrderEx(this.itemRec.orderStopFlagFn)) ignore = true;
    if (id == "minZai" && !this.commonService.config.paramItemMinZaiEditable) ignore = true;
    if (id == "maxZai" && !this.commonService.config.paramItemMaxZaiEditable) ignore = true;
    if (id == "minStockDays" && !this.commonService.config.paramItemMinStockDaysEditable) ignore = true;
    if (id == "maxStockDays" && !this.commonService.config.paramItemMaxStockDaysEditable) ignore = true;
    if (ignore) {
      this.keypadTargetId = undefined;
      this.numberKeypadComponent.inputField = undefined;
      return;
    }

    this.keypadTargetId = id;
    // this.numberKeypadComponent.inputField = form;
    this.numberKeypadComponent.setTargetForm(form);
    if (id == "inputItemCd") {
      this.numberKeypadComponent.setMaxCol(13);
      this.numberKeypadComponent.setStringMode();
      this.numberKeypadComponent.clearAtFirstInput(false);
    } else {
      this.numberKeypadComponent.clearMaxCol();
    }

  }

  zaiValidator(fg:FormGroup) {
    var err = {BadValue: "最低、最大が逆転しています。"};

    if (fg.get("minZaiForm").value != "" &&
        fg.get("maxZaiForm").value != "" &&
        parseInt(fg.get("minZaiForm").value) > parseInt(fg.get("maxZaiForm").value)) {
      return err;
    } else {
      return null;
    }
  }

  stockDaysValidator(fg:FormGroup) {
    var err = {BadValue: "最低、最大が逆転しています。"};

    if (fg.get("minStockDaysForm").value != "" &&
        fg.get("maxStockDaysForm").value != "" &&
        parseInt(fg.get("minStockDaysForm").value) > parseInt(fg.get("maxStockDaysForm").value)) {
      return err;
    } else {
      return null;
    }
  }

  minZaiValidator(fc:FormControl) {
    return this.paramRangeValidator(
      fc,
      this.commonService.config.paramItemMinStockDaysRange.min,
      this.commonService.config.paramItemMinStockDaysRange.max,
      "最低在庫日数");
  }

  paramRangeValidator(fc: FormControl, min:number, max:number, type:string) {
    var err = {"ValueRange": type + "の範囲は [ " + min + " ～ " + max + " ] です。"};
    if (parseInt(fc.value) < min || parseInt(fc.value) > max) {
      return err;
    } else {
      return null;
    }
  }

  isValueChanged() {
    if (!this.itemRec) return false;

    if (parseInt(this.orderForm.value) != this.itemRec.orderNumCurrentFn) return true;
    if (parseInt(this.stockForm.value) != this.itemRec.stockNumCurrentFn) return true;
    if (this.minZaiForm.value != this.itemRec.minZaiCurrentFv) return true;
    if (this.maxZaiForm.value != this.itemRec.maxZaiCurrentFv) return true;
    if (this.minStockDaysForm.value != this.itemRec.minStockDaysCurrentFv) return true;
    if (this.maxStockDaysForm.value != this.itemRec.maxStockDaysCurrentFv) return true;
    if (parseInt(this.orderStopForm.value) != this.itemRec.orderStopFlagCurrentFn) return true;

    return false;
  }

  groupValidator(fg:FormGroup, itemRec: ItemRec) {
    var isErr = false;    
    var err : object;
    var errs : object = {};

    if (!itemRec) return null;

    if (this.isOrderEditable) {
      var orderForm = fg.get("orderForm");
      err = Validators.required(orderForm);
      orderForm.setErrors(err);
    }
    if (this.isStockEditable) {
      var stockForm = fg.get("stockForm");
      err = Validators.required(stockForm);
      stockForm.setErrors(err);
    }

    var minZaiForm = fg.get("paramForm").get("minZaiForm");
    var maxZaiForm = fg.get("paramForm").get("maxZaiForm");
    if (minZaiForm.value !== "" && maxZaiForm.value !== "" &&
        parseInt(minZaiForm.value) > parseInt(maxZaiForm.value)) {
      errs["MinZaiBadValue"] = "最低、最大が逆転しています。";
      isErr = true;
    }
    var minStockDaysForm = fg.get("paramForm").get("minStockDaysForm");
    var maxStockDaysForm = fg.get("paramForm").get("maxStockDaysForm");
    if (minStockDaysForm.value !== "" && maxStockDaysForm.value !== "" &&
        parseInt(minStockDaysForm.value) > parseInt(maxStockDaysForm.value)) {
      errs["StockDaysBadValue"] = "最低、最大が逆転しています。";
      isErr = true;
    }

    if (!this.isValueChanged()) {
      errs["NoChange"] = "値の変更がありません。";
      isErr = true;
    }

    if (isErr) {
      return errs;
    } else {
      return null;
    }
  }

  btnQuery() {
    if (this.inputItemCdForm.value === "") return;

    this.nextJanCode = this.inputItemCdForm.value;
    let deactivate = this.canDeactivate();
    if (deactivate == true) {
      this.queryItem();
      return;
    }
    this.subscriptionConfirm = (deactivate as Observable<boolean>).subscribe(
      response => {
        if (response == true) {
          this.queryItem();
        } else {
          this.subscriptionConfirm.unsubscribe();
          this.subscriptionConfirm = undefined;
        }
      }
    );

  }

  itemRecProp(key: string) {
    if (!this.itemRec) return '';
    return this.itemRec[key];
  }

  clearProgressState() {
    this.commonService.closeSpinner();
    if (this.subscriptionQuery) {
      this.subscriptionQuery.unsubscribe();
      this.subscriptionQuery = undefined;
    }
  }

  queryItem() {
    this.commonService.openSpinner(this.commonService.pageTitle, "検索中・・・");

    var request : ReqItemSearch = {
      access: {...this.commonService.loginUser},
      itemSearchCondition : {
        calcTrgtDateFd: this.commonService.salesDate,
        // storeCdFv: this.itemSelectSimpleCondition.formGroup.get("storeCd").value,
        storeCdFv: this.storeForm.value,
        ctgCd0Fv: "",
        ctgCd1Fv: "",
        ctgCd2Fv: "",
        ctgCd3Fv: "",
        rackCd1Fn: 0,
        rackCd2Fn: 0,
        rackCd3Fn: 0,
        itemCdFv: this.nextJanCode,
        itemCdEqualSearch: true,
        itemNameFv: "",
        orderCurrentOperator: 0,
        orderCurrentNum: 0,
        orderInitialOperator: 0,
        orderInitialNum: 0,
        stockCurrentOperator: 0,
        stockCurrentNum: 0,
        stockInitialOperator: 0,
        stockInitialNum: 0,
      },
      page: {
        pageNum: 0,
        dispNum: 1
      }
    }

    this.subscriptionQuery = this.httpBasic.itemSearch(request).subscribe(
      response => this.receiveQueryItem(response),
      error => {
        this.clearProgressState();
        this.httpBasic.handleError(error);
      }
    );

  }

  receiveQueryItem(response: RspItemSearch) {
    this.clearProgressState();
    if (this.httpBasic.handleAppError(response)) return;

    if (response.recordCount == 0) {
      this.commonService.openErrorDialog(this.commonService.pageTitle, "商品 [ " + this.nextJanCode + " ] が見つかりませんでした。");
      this.nextJanCode = "";
      return;
    }

    this.nextJanCode = "";
    this.itemRec = new ItemRec(response.rows[0], this.commonService);
    this.orderStopInitial = this.commonService.getOrderStopFlagName(this.itemRec.orderStopFlagFn);
    this.setCurrentValue();
    this.formGroup.enable();
    this.keypadTargetId = undefined;
    this.numberKeypadComponent.inputField = undefined;

    if (!this.commonService.getOrderStopFlagCanOrder(this.itemRec.orderStopFlagFn)) {
      if (this.commonService.getOrderStopFlagCanOrderEx(this.itemRec.orderStopFlagFn)) {
        this.orderErrorMessage = "この商品は" + this.commonService.getOrderStopFlagName(this.itemRec.orderStopFlagFn) + "商品です。"
      } else {
        this.orderErrorMessage = "この商品は発注が許可されていないため、発注数の変更はできません。"
      }
      // this.orderForm.disable();
    } else {
      var orderDate: Date = new Date(
        +this.itemRec.orderDate.substring(0, 4),
        +this.itemRec.orderDate.substring(5, 7) - 1,
        +this.itemRec.orderDate.substring(8, 10)
      );
      var dayOfWeek = orderDate.getDay();
      // if (this.itemRec.orderableDateFv.substring(dayOfWeek, dayOfWeek+1) === '0')
      if (this.checkOrderWeekday() == false) {
        /* 発注不可曜日 */
        this.orderErrorMessage = "この商品の発注日は「"
        for (var i :number = 0; i < 7; i++) {
          if (this.itemRec.orderableDateFv.substring(i, i+1) !== '0') {
            this.orderErrorMessage += ["日", "月", "火", "水", "木", "金", "土"][i];
          }
        }
        this.orderErrorMessage += "」のため、発注数の変更はできません。"
      } else {
        this.orderErrorMessage = undefined;
        // this.orderForm.enable();
      }
    }

    if (!this.commonService.getOrderStopFlagChangeable(this.itemRec.orderStopFlagFn)) {
      this.orderStopList = this.commonService.config.orderStopFlag;
      this.orderStopErrorMessage = "この商品の自動発注種別の選択は許可されていません。"
      this.orderStopForm.disable();
    } else {
      this.orderStopList = this.commonService.getOrderStopSelectList();
      this.orderStopErrorMessage = undefined;
      this.orderStopForm.enable();
    }

    /*
    if (this.commonService.config.isHSD || this.commonService.config.scanFullScreen) {
      if ((this.isOrderEditable && this.orderErrorMessage != undefined) ||
          (this.isOrderStopEditable && this.orderStopErrorMessage != undefined)) {
        this.fullScreenWithError = true;
        document.getElementById("inner-container").style.transform = "scale(1.0)";
        let delay = 1000;
        if (this.commonService.config.delayAfterFullScreen) delay = this.commonService.config.delayAfterFullScreen;
        setTimeout(() => {this.scaleContainer();}, delay);
      } else if (this.fullScreenWithError) {
        this.fullScreenWithError = false;
        document.getElementById("inner-container").style.transform = "scale(1.0)";
        let delay = 1000;
        if (this.commonService.config.delayAfterFullScreen) delay = this.commonService.config.delayAfterFullScreen;
        setTimeout(() => {this.scaleContainer();}, delay);
      }
    }
    */
  }

  checkOrderWeekday() {
    var orderDate: Date = new Date(
      +this.itemRec.orderDate.substring(0, 4),
      +this.itemRec.orderDate.substring(5, 7) - 1,
      +this.itemRec.orderDate.substring(8, 10)
    );
    var dayOfWeek = orderDate.getDay();
    if (this.itemRec.orderableDateFv.substring(dayOfWeek, dayOfWeek+1) === '0') {
      return false;
    } else {
      return true;
    }
  }

  updateOrder() {
    this.commonService.openSpinner(this.commonService.pageTitle, "更新中・・・");

    if (parseInt(this.orderForm.value) == this.itemRec.orderNumCurrentFn) {
      this.updateStock();
      return;
    };

    this.subscriptionQuery = this.httpBasic.updateOrderNum(this.itemRec, this.orderForm.value).subscribe(
      response => this.receiveOrder(response),
      error => {
        this.clearProgressState();
        this.httpBasic.handleError(error);
      }
    );

  }
  receiveOrder(response: RspOrderEdit) {
    if (this.httpBasic.handleAppError(response)) {
      this.clearProgressState();
      return;
    }

    var rspOrderEditDto: RspOrderEditDto;
    rspOrderEditDto = response.result;
    this.itemRec.setOrderNum(rspOrderEditDto.orderNumFn,
      rspOrderEditDto.versionFn);

    this.updateStock();
  }

  updateStock() {
    if (parseInt(this.stockForm.value) == this.itemRec.stockNumCurrentFn) {
      this.updateParam();
      return;
    };

    this.subscriptionQuery = this.httpBasic.updateStockNum(this.itemRec, this.stockForm.value).subscribe(
      response => this.receiveStock(response),
      error => {
        this.clearProgressState();
        this.httpBasic.handleError(error);
      }
    );
  }
  receiveStock(response: RspStockEdit) {
    if (this.httpBasic.handleAppError(response)) {
      this.clearProgressState();
      return;
    }

    var rspStockEditDto: RspStockEditDto;
    rspStockEditDto = response.result;
    this.itemRec.setStockNum(rspStockEditDto.stockNumFn,
      rspStockEditDto.versionFn);

    this.updateParam();
  }

  updateParam() {
    if (this.minZaiForm.value == this.itemRec.minZaiCurrentFv &&
    this.maxZaiForm.value == this.itemRec.maxZaiCurrentFv &&
    this.minStockDaysForm.value == this.itemRec.minStockDaysCurrentFv &&
    this.maxStockDaysForm.value == this.itemRec.maxStockDaysCurrentFv) {
      this.updateOrderStop();
      return;
    };

    var minZai = this.minZaiForm.value;
    var maxZai = this.maxZaiForm.value;
    var minStockDays = this.minStockDaysForm.value;
    var maxStockDays = this.maxStockDaysForm.value;

    var reqParamItemEdit: ReqParamItemEdit = {
      access: {...this.commonService.loginUser},
      paramItemEdit: {
        storeCdFv:              this.itemRec.storeCdFv,
        itemCdFv:               this.itemRec.itemCdFv,
        minZaiIsNull:           this.itemRec.minZaiIsNull,
        minZaiFn:               this.itemRec.minZaiFn,
        minZaiModIsNull:        this.itemRec.minZaiModIsNull,
        minZaiModFn:            -1, // this.itemRec.minZaiModFn,
        minZaiVersionFn:        this.itemRec.minZaiVersionFn,
        maxZaiIsNull:           this.itemRec.maxZaiIsNull,
        maxZaiFn:               this.itemRec.maxZaiFn,
        maxZaiModIsNull:        this.itemRec.maxZaiModIsNull,
        maxZaiModFn:            -1, // this.itemRec.maxZaiModFn,
        maxZaiVersionFn:        this.itemRec.maxZaiVersionFn,
        minStockDaysIsNull:     this.itemRec.minStockDaysIsNull,
        minStockDaysFn:         this.itemRec.minStockDaysFn,
        minStockDaysModIsNull:  this.itemRec.minStockDaysModIsNull,
        minStockDaysModFn:      -1, // this.itemRec.minStockDaysModFn,
        minStockDaysVersionFn:  this.itemRec.minStockDaysVersionFn,
        maxStockDaysIsNull:     this.itemRec.maxStockDaysIsNull,
        maxStockDaysFn:         this.itemRec.maxStockDaysFn,
        maxStockDaysModIsNull:  this.itemRec.maxStockDaysModIsNull,
        maxStockDaysModFn:      -1, // this.itemRec.maxStockDaysModFn,
        maxStockDaysVersionFn:  this.itemRec.maxStockDaysVersionFn,
        autoOrderLotModFn:      -1,
        autoOrderLotModVersionFn: this.itemRec.autoOrderLotModVersionFn
      }
    };

    if (minZai != this.itemRec.minZaiCurrentFv) {
      reqParamItemEdit.paramItemEdit.minZaiModFn = this.paramToNumber(minZai);
      reqParamItemEdit.paramItemEdit.minZaiModIsNull = this.paramIsNull(minZai);
    }
    if (maxZai != this.itemRec.maxZaiCurrentFv) {
      reqParamItemEdit.paramItemEdit.maxZaiModFn = this.paramToNumber(maxZai);
      reqParamItemEdit.paramItemEdit.maxZaiModIsNull = this.paramIsNull(maxZai);
    }
    if (minStockDays != this.itemRec.minStockDaysCurrentFv) {
      reqParamItemEdit.paramItemEdit.minStockDaysModFn = this.paramToNumber(minStockDays);
      reqParamItemEdit.paramItemEdit.minStockDaysModIsNull = this.paramIsNull(minStockDays);
    }
    if (maxStockDays != this.itemRec.maxStockDaysCurrentFv) {
      reqParamItemEdit.paramItemEdit.maxStockDaysModFn = this.paramToNumber(maxStockDays);
      reqParamItemEdit.paramItemEdit.maxStockDaysModIsNull = this.paramIsNull(maxStockDays);
    }

    this.subscriptionQuery = this.httpBasic.updateItemParam(reqParamItemEdit).subscribe(
      response => this.receiveParam(response),
      error => {
        this.clearProgressState();
        this.httpBasic.handleError(error);
      }
    );
  }
  paramToNumber(val: string) {
    return val === "" ? 0 : parseInt(val);
  }
  paramIsNull(val: string) {
    return val === "" ? true : false;
  }
  receiveParam(response: RspParamItemEdit) {
    if (this.httpBasic.handleAppError(response)) {
      this.clearProgressState();
      return;
    }

    this.itemRec.setMinZai(response.result.minZaiModFn, response.result.minZaiVersionFn);
    this.itemRec.setMaxZai(response.result.maxZaiModFn, response.result.maxZaiVersionFn);
    this.itemRec.setMinStockDays(response.result.minStockDaysModFn, response.result.minStockDaysVersionFn);
    this.itemRec.setMaxStockDays(response.result.maxStockDaysModFn, response.result.maxStockDaysVersionFn);

    this.updateOrderStop();
  }

  updateOrderStop() {
    if (parseInt(this.orderStopForm.value) == this.itemRec.orderStopFlagCurrentFn) {
      this.clearProgressState();
      return;
    };

    var request : ReqOrderStopItemEdit = {
      access: {...this.commonService.loginUser},
      orderStopFlag : {
        storeCdFv: this.itemRec.storeCdFv,
        itemCdFv: this.itemRec.itemCdFv,
        orderStopFlagFn: this.itemRec.orderStopFlagFn,
        orderStopFlagModFn: parseInt(this.orderStopForm.value),
        orderStopFlagVersionFn: this.itemRec.orderStopFlagVersionFn
      }
    }
    this.subscriptionQuery = this.httpBasic.updateItemOrderStop(request).subscribe(
      response => this.receiveOrderStop(response),
      error => {
        this.clearProgressState();
        this.httpBasic.handleError(error);
      }
    );
  }
  receiveOrderStop(response: RspOrderStopItemEdit) {
    this.commonService.closeSpinner();
    if (this.httpBasic.handleAppError(response)) {
      this.clearProgressState();
      return;
    }

    var orderStopItemResultDto: OrderStopItemResultDto;
    orderStopItemResultDto = response.result;
    this.itemRec.setOrderStopFlag(
      orderStopItemResultDto.orderStopFlagModFn,
      orderStopItemResultDto.orderStopFlagVersionFn
    );
  }

  doCancel() {
    this.setCurrentValue();
    this.keypadTargetId = undefined;
    this.numberKeypadComponent.inputField = undefined;  }

  setCurrentValue() {
    if (!this.itemRec) return;
    this.orderForm.setValue(this.itemRec.orderNumCurrentFn);
    this.stockForm.setValue(this.itemRec.stockNumCurrentFn);
    this.minZaiForm.setValue(this.itemRec.minZaiCurrentFv);
    this.maxZaiForm.setValue(this.itemRec.maxZaiCurrentFv);
    this.minStockDaysForm.setValue(this.itemRec.minStockDaysCurrentFv);
    this.maxStockDaysForm.setValue(this.itemRec.maxStockDaysCurrentFv);
    this.orderStopForm.setValue(this.itemRec.orderStopFlagCurrentFn);
    this.formGroup.markAsPristine();
  }

  openBarcodeDialog() {
    const dialogRef = this.commonService.dialog.open(BarcodeDialogComponent, {
      disableClose: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(
      data => {
        if (data != undefined && data != null) {
          this.inputItemCdForm.setValue(data);
          this.btnQuery();
        }
      }
    )
  }

  canDeactivate() {
    if (!this.isValueChanged()) return true;

    return this.commonService.openYesNoDialog(this.commonService.pageTitle, "変更が保存されていません。変更内容を破棄しますか？");
  }
}
